var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDentalVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "63px",
    viewBox: "0 0 62 63",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dental") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dental Icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6418,59.2313 C38.6508,60.3223 40.2768,60.5493 41.5608,59.8003 C45.1618,57.7023 52.1128,51.1183 56.6748,38.1933 C59.1448,31.1983 59.9858,24.6293 59.7088,19.0403 C59.2408,9.6183 55.5008,0.2503 29.9498,0.2503 C4.3988,0.2503 0.7688,9.6183 0.3008,19.0403 C0.0238,24.6293 0.8648,31.1983 3.3348,38.1933 C7.9258,51.2013 14.9368,57.7723 18.5168,59.8403 C19.7778,60.5683 21.3788,60.3003 22.3668,59.2313 L25.7768,54.4783 C28.0558,52.0123 31.9538,52.0123 34.2328,54.4783 L37.6418,59.2313 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0608,19.4974 C9.0608,19.4974 10.1248,8.8514 21.8358,8.8514",
    id: "Stroke-3",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalVertical);
export default __webpack_public_path__ + "static/media/dental-vertical.847b25be5514eae101b617d227d10035.svg";
export { ForwardRef as ReactComponent };